import React from "react";
import { default as MUIList } from "@mui/material/List";
import styled from "styled-components";

const StyledMUIList = styled(MUIList)``;

export const List = ({ component }) => {
  return <StyledMUIList component={component} />;
};
